<div class="product-section-container">

  <mat-nav-list>
    @for (link of links; track link) {
      <a mat-list-item [routerLink]="link.routerLink">
        <span mat-line>{{link.label}}</span>
      </a>
    }
  </mat-nav-list>
  
  <div class="">
    <mat-card>
      <mat-card-content>
        <router-outlet></router-outlet>
      </mat-card-content>
    </mat-card>
  </div>


</div>
